import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3d88bzqhj: FaireProductEntity = {
  token: "p_e3d88bzqhj",
  type: "product",
  name: "Fuzzy Slippers–Mama",
  brandToken: "b_9e5lkbzo3q",
  brandName: "The Darling Effect",
  imageUrl:
    "https://cdn.faire.com/fastly/87f559379645eed10b2f6376df70d77c7d7673b2c5ef97d8faabf7b875a67b63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/51c82543ea797792760b6ccedf802e30d6b02e8f89cb56f2c8bc7626894d194d.jpeg",
  ],
  priceDollars: 20.55,
  description:
    "Thoughtfully created to merchandise beautifully with our Made for Mama: Mother’s Day Collection\n\nTreat yourself to ultimate comfort with our Fuzzy Slippers! Soft, plush, and delightfully snuggly, our Fuzzy Slippers add a cozy touch to your at-home style while the bow adds a darling finish. Perfect for lazy mornings, late evenings, or lounging around the house while making every step feel like your walking on a fluffy cloud.\n\nWomen's Sizing:\nS/M: 5–7.5\nM/L: 8–10\n\nLightweight design with a durable hard sole\nSoft, fuzzy material inside and out for maximum comfort\nEasy slip-on style for everyday coziness\n\n\n\nWARNING: Cancer and Reproductive Harm - www.P65Warnings.ca.gov",
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:42.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
